export default {
      id: "icon-check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-check",
      toString: function () {
        return this.url;
      }
    }